interface RedirectOptions {
  isRealTime?: boolean;
  isArchive?: boolean;
  isSchedule?: boolean;
}

const redirectToAdminLogin = (
  navigation: any,
  order: any,
  options: RedirectOptions
) => {
  const { isRealTime, isArchive, isSchedule } = options;
  navigation.navigateTo("/login-admin", {
    state: {
      order,
      isRealTime,
      isArchive,
      isSchedule,
      isEdit: true,
    },
  });
};

export { redirectToAdminLogin }; export type { RedirectOptions };
